import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ReasonValidationSchema } from "@/common/schemas/reason.schema"
import { useMutation } from "@tanstack/react-query"

interface UseArchivePrivateCompanyProps {
  privateCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchivePrivateCompanyLead = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseArchivePrivateCompanyProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archivePrivateCompany'],
    mutationFn: async ({ log_reason, newStatus }: { log_reason: ReasonValidationSchema, newStatus: string }) => {
      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}/${newStatus}`, { log_reason })
    },
    onSuccess,
    onError,
  })
}
